const CollectionList = {
  "options": {
    "data": {},
    "customization": {
      "items": {
        "type": "CategorySelector",
        "order": 1
      },
      "textSize": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 2
      },
      "childTextSize": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 3
      },
      "textColor": {
        "type": "HexColor",
        "order": 4
      },
      "childTextColor": {
        "type": "HexColor",
        "order": 5
      },
      "borderColor": {
        "type": "HexColor",
        "order": 6
      },
      "textWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "order": 7
      },
      "imageTextWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "order": 8
      },
      "containerPadding": {
        "type": "FourPx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 9
      },
      "gap": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 10
      }
    },
    "widgets": {
      "ToggleRadioTabs_1": {
        "type": "ToggleRadioTabs",
        "order": 11,
        "renderOptions": {
          "direction": "row",
          "controlKey": "backgroundType"
        },
        "options": {
          "backgroundImage": {
            "type": "ImageUploader"
          },
          "backgroundColor": {
            "type": "HexColor"
          }
        }
      }
    }
  },
  "variants": [
    {
      "id": "CollectionList_1",
      "name": "CollectionList_1",
      "type": "CollectionList",
      "data": {
        "images": []
      },
      "customization": {
        "textSize": "20px",
        "childTextSize": "10px",
        "textColor": "#000000",
        "childTextColor": "#000000",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "backgroundImage": "",
        "backgroundType": "-",
        "containerPadding": "4px 4px 4px 4px",
        "gap": "4px",
        "items": [],
        "borderColor": "#C1A7FF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/collectionList_1.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "CollectionList_2",
      "name": "CollectionList_2",
      "type": "CollectionList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textSize": "20px",
        "childTextSize": "10px",
        "textColor": "#000000",
        "childTextColor": "#000000",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "backgroundImage": "",
        "backgroundType": "-",
        "containerPadding": "4px 4px 4px 4px",
        "gap": "4px",
        "items": [],
        "borderColor": "#C1A7FF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/collectionList_1.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionList_3",
      "name": "CollectionList_3",
      "type": "CollectionList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textSize": "20px",
        "childTextSize": "10px",
        "textColor": "#000000",
        "childTextColor": "#000000",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "backgroundImage": "",
        "backgroundType": "-",
        "containerPadding": "4px 4px 4px 4px",
        "gap": "4px",
        "items": [],
        "borderColor": "#C1A7FF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/collection_list_3.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "CollectionList_5",
      "name": "CollectionList_5",
      "type": "CollectionList",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textSize": "14px",
        "textColor": "#000000",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "backgroundImage": "",
        "backgroundType": "-",
        "containerPadding": "4px 4px 4px 4px",
        "gap": "4px",
        "items": [],
        "borderColor": "#C1A7FF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/collectionList_5.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ]
}
 export default CollectionList